module.exports = __webpack_public_path__ + "img/John_Julie_Nixon@3x.a623931c.webp";